import './BundleChart.scss';

import React, { useEffect, useRef, useState } from 'react';
import { assertNever } from 'src/utils/assert';
import { SentinelBundleTube } from '../../models/bundle';
import {
  SquareBundleChartController,
  TriangleBundleChartController,
  type BundleChartController,
} from './BundleChartControllers';

interface BundleChartProps {
  tubes: SentinelBundleTube[];
  pattern: 'square' | 'triangle';
  isRotated: boolean;
}

export const BundleChart: React.FC<BundleChartProps> = ({ tubes, pattern, isRotated }) => {
  /** Ref object that contains the element under which the chart is created. */
  const graphRef = useRef<SVGSVGElement>(null);
  const [ctrl, setCtrl] = useState<BundleChartController | undefined>(undefined);

  // Effect that creates the svg graph element on mount, and destroys it on unmount.
  useEffect(() => {
    const graph = graphRef.current;
    if (graph) {
      const ctrl =
        pattern === 'square'
          ? new SquareBundleChartController(graph, isRotated)
          : pattern === 'triangle'
            ? new TriangleBundleChartController(graph, isRotated)
            : assertNever(pattern);
      setCtrl(ctrl);
    } else {
      console.warn('The component mounted but chartRef was null! The graph will not draw.');
    }
  }, [isRotated, pattern]);

  // Effect that updates the circles each time the data changes.
  useEffect(() => {
    ctrl?.setData(tubes);
  }, [ctrl, tubes]);

  return <svg ref={graphRef} preserveAspectRatio="xMidYMid meet" style={{ display: 'block' }} />;
};
